function mainLevelSelection(){
    const firstLevelContainers = window.document.querySelectorAll('.js_level-0');

    if (firstLevelContainers.length < 1) return;

    firstLevelContainers.forEach(firstLevelContainer =>{
        firstLevelContainer.addEventListener('click',function(e){
            const container = firstLevelContainer.closest('details');
            
            if (!container?.classList.contains('is-open')) return;
            
            e.stopPropagation();
        });
    });
}

function customFilterMainContainer(){
    const toggler = window.document.querySelector('.js_custom-filter-main-accordion');

    if (!toggler) return;
    toggler.addEventListener('click',function(){
        const panel = this.nextElementSibling;
        if (this.hasAttribute('open')){
            panel.style.maxHeight = null;
        }
        else{
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });

}

window.addEventListener('load',mainLevelSelection);